export enum BenchmarkColumns {
	PROFITS = "profits",
	LOSSES = "losses",
	DIFFERENCE = "difference",
}

export const switchingBenchmarkHeader = [
	BenchmarkColumns.PROFITS,
	BenchmarkColumns.LOSSES,
	BenchmarkColumns.DIFFERENCE,
]

export const ROW_CLASSNAME = "row-data"

export const SWITCHING_BENCHMARK_FLAG_ID = "switchingBenchmarkTable"
